/* eslint-disable max-len */
import React, { Component } from 'react';
import commonUI from '../../../js/commonUI';
import { addClasses, removeClasses, setStyles } from '../../../js/utils/html';
import DarkThemeNav from '../common/dark-theme-nav';

class Toasts extends Component {

  componentDidMount() {
    setTimeout(() => {
      this.initializeToasts();
    }, 0);
  }

  initializeToasts() {
    this.toasts = commonUI.initializeToasts({
      top: 48,
      cssClass: 'js-toasts--example',
    });
    const btnShowToast = document.getElementById('btnShowToast');
    const toastPosition = document.getElementById('toast-position');
    btnShowToast.addEventListener('click', this.showToast.bind(this), false);
    toastPosition.addEventListener('change', this.changeToastPosition.bind(this), false);
  }

  changeToastPosition(event) {
    const position = event.currentTarget.value;
    const toastsEl = document.querySelector('.js-toasts--example');
    removeClasses(toastsEl, [ 'toasts--position-top', 'toasts--position-right', 'toasts--position-bottom', 'toasts--position-left' ]);
    const positions = position.split('|');
    const toastClasses = [];
    for (const pos of positions) {
      toastClasses.push(`toasts--position-${ pos }`);
    }
    if (positions.includes('top')) {
      setStyles(toastsEl, { top: '48px', bottom: 'auto' });
    } else {
      setStyles(toastsEl, { top: 'auto', bottom: '0px' });
    }
    addClasses(toastsEl, toastClasses);
  }

  showToast() {
    const toastType = document.getElementById('toast-type').value;
    const toastOutlined = document.getElementById('toast-outlined').checked;
    this.toasts.add({
      type: toastType,
      outline: toastOutlined,
      message: `This is an example <strong>${ toastType }</strong> message.`,
    });
  }

  render() {
    return (
      <section><a className="anchor"id="toasts"></a>
      <h2>Toasts</h2>
      <p>Toasts are required to allow applications to notifiy users of events which are being carried out in the background via an application or website.</p>

      <DarkThemeNav anchor="toasts" />

      <ul className="toasts toasts--position-left hard position--relative">
        <li className="toast toast--error toast--outline">
          <span className="toast__icon"><i className="fa fa-remove"></i></span>
          <span className="toast__message">This is an error toast with a <a href="#">link</a></span>
          <button className="toast__action"><i className="fa fa-remove"></i></button>
        </li>
        <li className="toast toast--warning toast--outline">
          <span className="toast__icon"><i className="fa fa-exclamation"></i></span>
          <span className="toast__message">This is an exclamation toast with a <a href="#">link</a></span>
          <button className="toast__action"><i className="fa fa-remove"></i></button>
        </li>
        <li className="toast toast--success toast--outline">
          <span className="toast__icon"><i className="fa fa-check"></i></span>
          <span className="toast__message">This is a success toast with a <a href="#">link</a></span>
          <button className="toast__action"><i className="fa fa-remove"></i></button>
        </li>
        <li className="toast toast--info toast--outline">
          <span className="toast__icon"><i className="fa fa-info"></i></span>
          <span className="toast__message">This is an info toast with a <a href="#">link</a></span>
          <button className="toast__action"><i className="fa fa-remove"></i></button>
        </li>
      </ul>

      <br/>

      <h3>Usage</h3>
      <pre><code className="language-javascript">{`let toasts = commonUI.initializeToasts();`}</code></pre>
      <br/>
      <h3>Toasts Options</h3>

      <p>The <code>commonUI.initializeToasts()</code> shown above will imply the default options as shown below:</p>
      <table className="table table--striped table--cosy">
        <thead>
          <tr>
            <th className="text--left">Property</th>
            <th>Type</th>
            <th>Default</th>
            <th className="text--left">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>position</td>
            <td className="text--center">string</td>
            <td className="text--center"><code>'top|right'</code></td>
            <td>This is a string representing the position of the toasts container.<br/>Options are <code>'top|right'</code>, <code>'bottom|right'</code>, <code>'bottom|left'</code> or <code>'top|left'</code></td>
          </tr>
          <tr>
            <td>cssClass</td>
            <td className="text--center">string</td>
            <td className="text--center"><code>'js-toasts'</code></td>
            <td>You can specify an optional CSS class, which you can then use as a selector in your application code.</td>
          </tr>
          <tr>
            <td>maxToasts</td>
            <td className="text--center">integer</td>
            <td className="text--center"><code>3</code></td>
            <td>The maximum number of toasts that can be displayed at one time.</td>
          </tr>
        </tbody>
      </table>
      <p>These options can be overridden by passing an object to the <code>commonUI.initializeToasts()</code> function, for example:</p>

      <pre><code className="language-javascript">{`// Initialize the toasts component
let toasts = commonUI.initializeToasts({
  cssClass: 'js-my-toasts',
  position: 'bottom|left',
  maxToasts: 5
});`}</code></pre>

      <br/>
      <h4>Additional Options</h4>
      <p>Optionally, you can also position the toasts container relative to the top, right, bottom or left edge of the viewport, for example:</p>
      <pre><code className="language-javascript">{`// Position the toasts component 100px down from the top and 50px in from the right
let toasts = commonUI.initializeToasts({
  top: 100,
  right: 50
});`}</code></pre>

      <br/>
      <div className="callout">
        <strong>Note:</strong> When specifying an offset for <code>top</code>, <code>right</code>, <code>bottom</code> or <code>left</code>, you must <strong>only</strong> apply either <code>left</code> OR <code>right</code> (not both), and either <code>top</code> OR <code>bottom</code> (not both).
      </div>

      <br/>

      <h3>Adding a Toast Message</h3>
      <p>To add a new toast message simply call the <code>add()</code> method on the <code>toasts</code> object created above, as shown below:</p>
      <pre><code className="language-javascript">{`toasts.add({ message = 'This is an example toast using the default options' });`}</code></pre>

      <br/>

      <p>This will imply the default toast options as shown below:</p>
      <table className="table table--striped table--cosy">
        <thead>
          <tr>
            <th className="text--left">Property</th>
            <th>Type</th>
            <th>Default</th>
            <th className="text--left">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>message</td>
            <td className="text--center">string</td>
            <td className="text--center"><code>''</code></td>
            <td>This is a string representing the message to displayed in the body of the toast.</td>
          </tr>
          <tr>
            <td>type</td>
            <td className="text--center">string</td>
            <td className="text--center"><code>'info'</code></td>
            <td>The type of the toast message. Can be one of <code>'info'</code>, <code>'success'</code>, <code>'warning'</code> or <code>'error'</code>.</td>
          </tr>
          <tr>
            <td>minDuration</td>
            <td className="text--center">integer</td>
            <td className="text--center"><code>2000</code></td>
            <td>The minimum duration (in milliseconds) that the toast message will be displayed for.</td>
          </tr>
          <tr>
            <td>maxDuration</td>
            <td className="text--center">integer</td>
            <td className="text--center"><code>7000</code></td>
            <td>The maximum duration (in milliseconds) that the toast message will be displayed for.</td>
          </tr>
          <tr>
            <td>outline</td>
            <td className="text--center">boolean</td>
            <td className="text--center"><code>false</code></td>
            <td>Whether the toast message should be outlined or not.</td>
          </tr>
        </tbody>
      </table>
      <p>These options can be overridden by passing an object when adding a new toast via the <code>toasts.add()</code> function, for example:</p>

      <pre><code className="language-javascript">{`// Add a new toast
toasts.add({
  type: 'success',
  message: 'This is an example of an outlined success toast message',
  outline: true,
  minDuration: 3000,
  maxDuration: 8000,
});`}</code></pre>

      <br/>
      <div className="callout">
        <strong>Note:</strong> The toast message will be displayed for a duration of 50ms per character. If this duration is outside the min/max duration specified (or defaults if not specified), then the min/max duration will take precedence.
      </div>

      <br/>

      <h4>Icon</h4>
      <p>By default, the icon will be determined based on the <code>type</code> of the toast message, as follows:</p>
      <table className="table table--striped table--cosy" style={{ width: '150px' }}>
        <thead>
          <tr>
            <th className="text--left">Type</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>info</code></td>
            <td className="text--center"><i className="fa fa-info"></i></td>
          </tr>
          <tr>
            <td><code>success</code></td>
            <td className="text--center"><i className="fa fa-check"></i></td>
          </tr>
          <tr>
            <td><code>warning</code></td>
            <td className="text--center"><i className="fa fa-exclamation"></i></td>
          </tr>
          <tr>
            <td><code>error</code></td>
            <td className="text--center"><i className="fa fa-remove"></i></td>
          </tr>
        </tbody>
      </table>

      <p>However, you can override the default icon if necessary by specifying a different icon from the <a href="#icons">icons</a> set, as follows:</p>

      <pre><code className="language-javascript">{`// Override the toast icon with a CME branded icon
toasts.add({
  type: 'info',
  message: '<strong>Joe Bloggs</strong> has sent you a message.<br/><a href="#">Click here</a> to view.',
  outline: true,
  icon: 'icon-cme-chat'
});`}</code></pre>

      <br/>
      <ul className="toasts toasts--position-left hard position--relative">
        <li className="toast toast--info toast--outline">
          <span className="toast__icon"><i className="icon-cme-chat"></i></span>
          <span className="toast__message"><strong>Joe Bloggs</strong> has sent you a message.<br/><a href="#">Click here</a> to view.</span>
          <button className="toast__action"><i className="fa fa-remove"></i></button>
        </li>
      </ul>

      <br/>
      <h3>Demo</h3>
      <p className="hard--bottom">Select a type, position and whether to outline the toast message and click the "Show Toast" button.</p>
      <ul className="form-fields list-inline">
        <li className="soft-half">
          <label htmlFor="toast-type">Type</label>
          <select id="toast-type">
            <option value="info">Info</option>
            <option value="success">Success</option>
            <option value="warning">Warning</option>
            <option value="error">Error</option>
          </select>
        </li>
        <li className="soft-half">
          <label htmlFor="toast-position">Position</label>
          <select id="toast-position">
            <option value="top|right">Top Right</option>
            <option value="bottom|right">Bottom Right</option>
            <option value="bottom|left">Bottom Left</option>
            <option value="top|left">Top Left</option>
          </select>
        </li>
        <li className="soft-half">
          <label>&nbsp;</label>
          <ul className="check-list">
            <li>
                <input type="checkbox" id="toast-outlined" /> <label htmlFor="toast-outlined">Outlined</label>
            </li>
          </ul>
        </li>
        <li className="soft">
          <button type="button" className="btn" id="btnShowToast">Show Toast</button>
        </li>
      </ul>

      <br/>
      <h3>Examples</h3>
      <p>The following is a demonstration of a series of random toast messages being added one every three seconds:</p>
      <div className="iframe-container" style={{ height: '410px', border: '1px solid #ccc' }}>
        <iframe seamless srcDoc={`<html>
          <head>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
            <link rel="stylesheet" type="text/css" href="css/commonUI.css">
            <link rel="stylesheet" type="text/css" href="css/styleguide.css">
          </head>
          <body>
          </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>

    const randomToasts = [
      {
        type: 'success',
        message: 'This is an outlined success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
        outline: true,
      }, {
        type: 'info',
        message: 'This is an outlined info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
        outline: true,
      }, {
        type: 'error',
        message: 'This is an outlined error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
        outline: true,
      }, {
        type: 'warning',
        message: 'This is an outlined warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
        outline: true,
      }, {
        type: 'success',
        message: 'This is a success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
      }, {
        type: 'info',
        message: 'This is an info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
      }, {
        type: 'error',
        message: 'This is an error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
      }, {
        type: 'warning',
        message: 'This is a warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>',
      }, {
        type: 'success',
        message: 'This is a really long outlined success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
        outline: true,
      }, {
        type: 'info',
        message: 'This is a really long outlined info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
        outline: true,
      }, {
        type: 'error',
        message: 'This is a really long outlined error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
        outline: true,
      }, {
        type: 'warning',
        message: 'This is a really long outlined warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
        outline: true,
      }, {
        type: 'success',
        message: 'This is a really long success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
      }, {
        type: 'info',
        message: 'This is a really long info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
      }, {
        type: 'error',
        message: 'This is a really long error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
      }, {
        type: 'warning',
        message: 'This is a really long warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon',
      },  {
        type: 'info',
        message: '<strong>Joe Bloggs</strong> has sent you a message.<br/><a href="#">Click here</a> to view.',
        icon: 'fa fa-user',
      },
    ];

    const getRandomToast = () => {
      const randomIndex = Math.floor(Math.random() * Math.floor(randomToasts.length));
      return randomToasts[randomIndex];
    }

    // const toasts = new Toasts({
    const toasts = commonUI.initializeToasts({
      position: 'top|right',
      outline: true,
      top: 0,
      right: 0
    });

    setInterval(() => {
      toasts.add(getRandomToast());
    }, 3000);

  </script>
</html>`}></iframe>
      </div>

      </section>
    );
  }
}

export default Toasts;



// WEBPACK FOOTER //
// ./styleguide/components/sections/Toasts.js